<template>
  <Loading v-if="isLoading"></Loading>
  <div v-else>
    <div class="employee" :class="employee_full_status ? 'employee-full' : ''">
      <!-- 頭部組件 -->
      <Header
        v-show="!employee_full_status"
        ref="HeaderRef"
        :agoraCamerasList="agoraCamerasList"
        :agoraMicrophoneList="agoraMicrophoneList"
        :agoraSpeakerList="agoraSpeakerList"
        @cameraChange="agoraCamerasChange"
        @microphoneChange="agoraMicrophoneChange"
        @speakerChange="agoraSpeakerChange"
        @exitClassroom="agoraLeave"
      />
      <div class="employee-box">
        <div class="employee-box-left">
          <!-- 畫板 -->
          <Sketchpad
            ref="SketchpadRef"
            @retrieveChats="retrieveChatsMessage"
            @newChatMessage="newChatMessage"
            @retrieveUserList="retrieveUserList"
            @clockIn="setClockIn"
            @clockOut="setClockOut"
            @student_drawing_permissions="changeStudentPermissions"
            @audioPlayStart="muteForAudio"
            @audioPlayStop="unmuteForAudio"
          />
        </div>
        <div class="employee-box-right" v-show="!employee_full_status">
          <!-- 老師畫面 -->
          <TeacherCamera
            :teacherName="teacherName"
            @teacherSpeakerSoundChange="teacherSpeakerSoundChange"
          />
          <!-- 學生畫面 -->
          <StudentCamera
            v-show="employee_camera_status"
            :studentName="studentName"
            :student_drawing_permissions="student_drawing_permissions"
            @studentSpeakerSoundChange="studentSpeakerSoundChange"
          />
          <!-- 員工畫面 -->
          <EmployeeCamera
            v-show="!employee_camera_status"
            @cameraChange="agoraCameraEnabled"
            @mikeChange="agoraMicrophoneEnabled"
          />
          <!-- 聊聊 -->
          <Chat
            ref="retrieveChatsMessage"
            @retrieveChats="retrieveChatsSketchpad"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgoraRTC from "agora-rtc-sdk-ng";
import Header from "./components/Header.vue";
import Sketchpad from "./components/Sketchpad.vue";
import TeacherCamera from "./components/TeacherCamera.vue";
import StudentCamera from "./components/StudentCamera.vue";
import EmployeeCamera from "./components/EmployeeCamera.vue";
import Chat from "./components/Chat.vue";
import Loading from "./components/Loading.vue";

export default {
  name: "Employee",
  components: {
    Header,
    Sketchpad,
    TeacherCamera,
    StudentCamera,
    EmployeeCamera,
    Chat,
    Loading,
  },
  data() {
    return {
      // 用戶信息
      userId: sessionStorage.getItem("agoraUid"),
      // agora配置
      // appId
      agoraAppId: process.env.VUE_APP_AGORA_APPID,
      // 頻道號
      agoraChannel: sessionStorage.getItem("agoraChannel"),
      // 根據頻道號生成的token
      agoraToken: sessionStorage.getItem("agoraToken"),
      // 加入 Uid = 33 + 用戶id
      agoraUid: Number("33" + sessionStorage.getItem("agoraUid")),
      // 視訊 Uid = 31 + 用戶id
      agoraCameraUid: Number("31" + sessionStorage.getItem("agoraUid")),

      // agora實例
      // 加入頻道實例
      agoraClient: null,
      // 視訊實例
      agoraCameraClient: null,
      // 視頻本地實例
      localCameraClient: null,
      // 音頻本地實例
      localMicrophoneClient: null,

      // 遠端音頻列表
      remoteUserAudioList: {},
      // 遠端視頻列表
      remoteUserVideoList: {},

      // 媒體設備列表
      // 視訊列表
      agoraCamerasList: [],
      agoraCamerasActive: "",
      // 麥克風列表
      agoraMicrophoneList: [],
      agoraMicrophoneActive: "",
      // 喇叭列表
      agoraSpeakerList: [],
      agoraSpeakerActive: "",

      // 上線驗證時間戳
      onlineTime: 0,
      // 上線驗證時長
      onlineSecond: 5,

      volume: 1, // initial volume
      isMuted: false, // initial mute state
      currentTimeVideo: 0, // initial current time
      duration: 0, // initial duration

      originalWidth: 0,
      originalHeight: 0,

      roomId: null,
      ClassKey: "eyJDbGFzc3Jvb21JZCI6MjIxNjUwMywiVXNlcklkIjoxNjg5MDh9",
      isLoading: true,
      userList: [],
      teacherName: "",
      studentName: "",
      student_drawing_permissions: null,
    };
  },
  computed: {
    ...mapGetters(["employee_full_status", "employee_camera_status"]),
    errorLogs() {
      return this.$store.getters.errorLogs;
    },
  },
  created() {
    this.isLoading = false;
    this.getMedia();
    this.agoraInit();
  },
  mounted() {
    this.$watch(
      () => this.localCameraClient,
      () => {
        // 播放本地視頻
        this.localCameraClient.play("local-employeeCamera");
      }
    );
  },
  methods: {
    //---------Agora----------//
    // 獲取媒體設備列表
    async getMedia() {
      // 獲取agora的視訊列表
      this.agoraCamerasList = await AgoraRTC.getCameras();
      this.agoraCamerasActive = this.agoraCamerasList?.[0]?.deviceId || "";
      // 獲取agora的麥克風列表
      this.agoraMicrophoneList = await AgoraRTC.getMicrophones();
      this.agoraMicrophoneActive =
        this.agoraMicrophoneList?.[0]?.deviceId || "";
      // 獲取agora的喇叭列表
      this.agoraSpeakerList = await AgoraRTC.getPlaybackDevices();
      this.agoraSpeakerActive = this.agoraSpeakerList?.[0]?.deviceId || "";
    },
    // 切換視訊設備
    agoraCamerasChange(val) {
      if (this.localCameraClient) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.localCameraClient
          .setDevice(val)
          .then(() => {
            console.log("切換視訊成功 => ");
          })
          .catch((err) => {
            console.log("切換視訊報錯 => ", err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        if (process.env.VUE_APP_RUN_STATE != "local") alert("切換異常，請刷新後重試！")
      }
    },
    // 切換麥克風設備
    agoraMicrophoneChange(val) {
      if (this.localMicrophoneClient) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.localMicrophoneClient
          .setDevice(val)
          .then(() => {
            console.log("切換麥克風成功 => ");
          })
          .catch((err) => {
            console.log("切換麥克風報錯 => ", err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        if (process.env.VUE_APP_RUN_STATE != "local") alert("切換異常，請刷新後重試！")
      }
    },
    // 切換喇叭設備
    agoraSpeakerChange(val) {
      for (let key in this.remoteUserAudioList) {
        this.remoteUserAudioList[key].audioTrack
          .setPlaybackDevice(val)
          .then(() => {
            console.log("切換喇叭成功 => ");
          })
          .catch((err) => {
            console.log("切換喇叭報錯 => ", err);
          });
      }
    },

    // 初始加入頻道 創建本地agora實例
    async agoraInit() {
      // 創建agora實例
      this.agoraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
      // 添加監聽事件 監聽用戶離開加入
      this.agoraClient.on("user-published", this.agoraUserPublished);
      this.agoraClient.on("user-unpublished", this.agoraUserUnpublished);
      this.agoraClient.on("user-joined", this.agoraUserJoined);
      // 創建一個時間戳 用於做上線驗證
      this.onlineTime = new Date().getTime();
      // 加入頻道
      await this.agoraClient.join(
        this.agoraAppId,
        this.agoraChannel,
        this.agoraToken,
        this.agoraUid
      );
      // 開啟視訊
      this.agoraCamera();
    },
    // 用戶監聽-監聽遠端用戶加入頻道 用於加入教室彈窗
    agoraUserJoined(user) {
      // 當前時間
      const nowTime = new Date().getTime();
      // 用當前時間和加入頻道時間對比 監聽用戶加入 彈出加入房間彈窗
      if (nowTime - this.onlineTime > this.onlineSecond * 1000) {
        this.$refs.HeaderRef.enteredHandel(user.uid);
      }
    },
    // 用戶監聽-訂閱遠端用戶發佈音視頻軌道
    async agoraUserPublished(user, mediaType) {
      console.log(
        "employee student camera",
        this.remoteUserVideoList,
        user.uid
      );
      // 訂閱遠程用戶
      await this.agoraClient.subscribe(user, mediaType);
      // 根據uid區分並渲染畫面
      const type = user.uid.toString().slice(0, 2);
      // 根據uid獲取用戶id
      const userId = user.uid.toString().slice(2, user.uid.length);
      // 音頻播放
      if (mediaType == "audio") {
        // 播放音頻 除開自己的
        if (userId != this.userId) {
          // 加入至列表暫存
          this.remoteUserAudioList[user.uid] = user;
          user.audioTrack.play();
        }
        // 根據type設置用戶的播放按鈕狀態  11老師 21學生
        if (type == 11) {
          // 設置音頻播放按鈕狀態
          this.$store.commit("SET_TEACHERMIKESTATUS_EMPLOYEE", true);
        }
        if (type == 21) {
          // 設置音頻播放按鈕狀態
          this.$store.commit("SET_STUDENTMIKESTATUS_EMPLOYEE", true);
        }
      }
      // 視頻播放
      if (mediaType == "video") {
        // 加入至列表暫存
        this.remoteUserVideoList[user.uid] = user;
        // 根據type設置用戶的播放按鈕狀態  11老師 21學生
        if (type == 11) {
          // 播放視頻
          user.videoTrack.play("local-teacherCamera");
          // 設置視頻播放按鈕狀態
          this.$store.commit("SET_TEACHERCAMERASTATUS_EMPLOYEE", true);
        }
        if (type == 21) {
          // 播放視頻
          user.videoTrack.play("local-studentCamera");
          // 設置視頻播放按鈕狀態
          this.$store.commit("SET_STUDENTCAMERASTATUS_EMPLOYEE", true);
        }
      }
    },
    // 用戶監聽-訂閱遠端用戶取消發佈音視頻軌道
    async agoraUserUnpublished(user, mediaType) {
      const type = user.uid.toString().slice(0, 2);
      // 判斷是不是老師的參數 是則關閉麥克風狀態
      if (type == 11) {
        if (mediaType == "audio") {
          this.$store.commit("SET_TEACHERMIKESTATUS_EMPLOYEE", false);
        }
        if (mediaType == "video") {
          this.$store.commit("SET_TEACHERCAMERASTATUS_EMPLOYEE", false);
        }
      }
      // 判斷是不是學生的參數 是則關閉麥克風狀態
      if (type == 21) {
        if (mediaType == "audio") {
          this.$store.commit("SET_STUDENTMIKESTATUS_EMPLOYEE", false);
        }
        if (mediaType == "video") {
          this.$store.commit("SET_STUDENTCAMERASTATUS_EMPLOYEE", false);
        }
      }
      if (this.remoteUserAudioList[user.uid]) {
        delete this.remoteUserAudioList[user.uid];
      }
      if (this.remoteUserVideoList[user.uid]) {
        delete this.remoteUserVideoList[user.uid];
      }
    },

    // 視訊實例創建及推流
    async agoraCamera() {
      // 創建agora實例
      this.agoraCameraClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      // 加入頻道
      await this.agoraCameraClient.join(
        this.agoraAppId,
        this.agoraChannel,
        this.agoraToken,
        this.agoraCameraUid
      );
      // 創建視頻流
      try {
        // Create video track
        this.localCameraClient = await AgoraRTC.createCameraVideoTrack();
        console.log("[Agora] 員工端攝像頭創建成功");
      } catch (cameraError) {
        // Handle camera error (e.g., show user warning)
        console.error("[Agora] 員工端攝像頭創建失敗", cameraError);
        this.$message.warning("無法開啟攝像頭，請檢查設備權限");
        this.localCameraClient = null; // Clear invalid reference
      }

      // 創建音頻流
      try {
        // Create audio track
        this.localMicrophoneClient = await AgoraRTC.createMicrophoneAudioTrack({
          AEC: true, // Enable Acoustic Echo Cancellation
          ANS: true, // Enable Automatic Noise Suppression
          AGC: true, // Enable Automatic Gain Control
        });
        console.log("[Agora] 員工端麥克風創建成功");
      } catch (micError) {
        // Handle microphone error
        console.error("[Agora] 員工端麥克風創建失敗", micError);
        this.$message.warning("無法開啟麥克風，請檢查設備權限");
        this.localMicrophoneClient = null;
      }

      // 加入訂閱推流
      const tracksToPublish = [];
      if (this.localCameraClient) tracksToPublish.push(this.localCameraClient);
      if (this.localMicrophoneClient) tracksToPublish.push(this.localMicrophoneClient);

      console.log("[Agora] 員工端準備發佈的軌道", tracksToPublish.map(t => t.trackMediaType));
      if (tracksToPublish.length > 0) {
        await this.agoraCameraClient.publish(tracksToPublish);
        console.log("[Agora] 員工端軌道發佈成功");
      }
      // // 播放本地視頻
      // this.localCameraClient.play("local-employeeCamera");

      // 同时切换默认设备
      this.agoraCamerasChange(this.agoraCamerasActive);
      this.agoraMicrophoneChange(this.agoraMicrophoneActive);
      this.agoraSpeakerChange(this.agoraSpeakerActive);
    },
    // 關閉視訊頻道
    async agoraCameraLeave() {
      // 關閉視頻軌道
      if (this.localCameraClient) {
        this.localCameraClient.stop();
        this.localCameraClient.close();
      }
      // 關閉音頻軌道
      if (this.localMicrophoneClient) {
        this.localMicrophoneClient.stop();
        this.localMicrophoneClient.close();
      }
      // 斷開客戶鏈接
      if (this.agoraClient) {
        await this.agoraClient.leave();
      }
    },
    // 視訊狀態開關
    async agoraCameraEnabled(val) {
      console.log("視訊狀態開關", val);
      if (this.localCameraClient) {
        await this.localCameraClient.setEnabled(val);
      }
    },
    // 播放 MP3 時靜音麥克風，避免揚聲器被採集產生回音
    async muteForAudio() {
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(false);
      }
    },
    // 暫停/停止 MP3 後恢復麥克風
    async unmuteForAudio() {
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(true);
      }
    },
    // 麥克風狀態開關
    async agoraMicrophoneEnabled(val) {
      console.log("麥克風狀態開關", val);
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(val);
      }
    },
    // 老師揚聲器音量調整
    teacherSpeakerSoundChange(num) {
      for (let key in this.remoteUserAudioList) {
        let type = key.toString().slice(0, 2);
        if (["11"].includes(type)) {
          this.remoteUserAudioList[key].audioTrack.setVolume(num);
        }
      }
    },
    // 學生揚聲器音量調整
    studentSpeakerSoundChange(num) {
      for (let key in this.remoteUserAudioList) {
        let type = key.toString().slice(0, 2);
        if (["21"].includes(type)) {
          this.remoteUserAudioList[key].audioTrack.setVolume(num);
        }
      }
    },

    // 離開頻道 停止所有本地播放
    async agoraLeave() {
      this.remoteUserAudioList = {};
      this.remoteUserVideoList = {};
      await this.agoraCameraLeave();
      sessionStorage.clear();
      this.$router.push("/?key=");
    },

    beforeJoinClass() {
      this.$store.dispatch("joinNewClassHitutor", {
        ClassKey: this.ClassKey,
      });
      this.$store.commit("setClassRoomKey", this.ClassKey);
    },
    retrieveChatsSketchpad(msg) {
      if (msg) {
        this.$refs.SketchpadRef.pushChatMessage(msg);
      } else {
        this.$refs.SketchpadRef.retrieveChats();
      }
    },
    retrieveChatsMessage() {
      this.$refs.retrieveChatsMessage.retrieveChatsMessage();
    },
    newChatMessage(msg) {
      this.$refs.retrieveChatsMessage.addMessage(msg);
    },
    retrieveUserList(data) {
      this.userList = data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].userType == 1) {
          this.teacherName = data[i].user;
        } else if (data[i].userType == 0) {
          this.studentName = data[i].user;
        }
      }
      const checkTeacherExist = data.some((i) => i.userType == 1);
      if (!checkTeacherExist) this.teacherName = "";
      const checkStudentExist = data.some((i) => i.userType == 0);
      if (!checkStudentExist) this.studentName = "";
    },
    changeStudentPermissions(data) {
      console.error(data);
      this.student_drawing_permissions = data;
    },
    setClockIn(val) {
      this.$refs.HeaderRef.setClockIn(val);
    },
    setClockOut() {
      this.$refs.HeaderRef.setClockOut();
    },

    //--------------------------------//
  },
  beforeDestroy() {
    // 頁面銷毀時 離開agora
    this.agoraLeave();
  },
};
</script>

<style lang="scss" scoped>
.employee {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .employee-box {
    padding: 0 20px 10px;
    height: calc(100% - 60px);
    display: flex;

    .employee-box-left {
      padding-right: 16px;
      flex: 1;
      min-width: 0;
    }

    .employee-box-right {
      width: 468px;
      flex-shrink: 0;
      overflow-y: auto;
    }
  }
}

.employee-full {
  .employee-box {
    padding: 0 150px;
    height: 100%;

    .employee-box-left {
      padding-right: 0;
    }
  }
}
</style>
